import { Autocomplete, Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
const GlobalSelectFieldWithoutFormikNew = ({
  label,
  data,
  selectedDetails,
  setChange,
  keys,
  sx,
  fullWidth,
  disabled = false,
  clearButton=false
}) => {
  const { itemId, itemValue } = keys;
  const handleChange = (e) => {
    const selectedId = e.target.value;
    const objectIs = data.find((objects) => objects[itemId] == selectedId);
    setChange((pvs) => ({
      ...pvs,
      id: objectIs[itemId],
      value: objectIs[itemValue],
    }));
  };

  return (
    <FormControl fullWidth={fullWidth} sx={sx}>
      <InputLabel>{label}</InputLabel>
      <Select
        disabled={disabled}
        name="selectField"
        label={label}
        value={selectedDetails?.id != null ? selectedDetails.id : ''}
        onChange={handleChange}
        endAdornment={
          selectedDetails?.id != null && !disabled && clearButton ? (
            <IconButton
              size="small"
              sx={{ mr: 2 }}  
              onClick={(e) => {
                e.stopPropagation(); 
                setChange({});
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          ) : null
        }
      >
        {data?.length > 0 &&
          data?.map((item) => (
            <MenuItem key={item[itemId]} value={item[itemId]}>
              {item[itemValue]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default GlobalSelectFieldWithoutFormikNew;
